export default ({data}) => {
    return (
        <>
            <br/><strong>Telefone</strong>: {data?.telephone}<br/>
            <strong>Linkedin</strong>: {data?.linkedin}<br/>
            <strong>E-mail</strong>: {data?.email}<br/>
            <strong>Cargo</strong>: {data?.cargo}<br/><br/>
        </>
    )
}